import React from 'react';
import PropTypes from 'prop-types';

import { toTitleCase } from '../utils/toTitleCase';
import { cleanLocationName } from '../utils/cleanLocationName';
import { cleanPathParam } from '../utils/cleanPathParam';

export const DealerItem = ({ name, city, locationId }) => {
	const locationDetailUrl = `/location-details/${encodeURIComponent(
		cleanPathParam(name)
	)}/${encodeURIComponent(cleanPathParam(city))}.htm`;
	return (
		<li key={locationId}>
			{toTitleCase(city)},{' '}
			<a
				href={locationDetailUrl}
				aria-label={`Visit location details page for ${name}`}
			>
				{cleanLocationName(name)}
			</a>
		</li>
	);
};

DealerItem.propTypes = {
	name: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	locationId: PropTypes.string.isRequired
};
